import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Footer';
import './styles/NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <div className="container">
        <div className="not-found-content">
          <h1 className="error-code">404</h1>
          <h2 className="error-title">Oldal nem található</h2>
          <p className="error-description">
            Sajnáljuk, a keresett oldal nem található. Lehetséges, hogy áthelyezték, törölték, vagy hibás a megadott cím.
          </p>
          <div className="error-actions">
            <Link to="/" className="home-button">
              Vissza a főoldalra
            </Link>
            <button 
              className="back-button" 
              onClick={() => window.history.back()}
            >
              Vissza az előző oldalra
            </button>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default NotFoundPage;
